import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import PeopleIcon from "@mui/icons-material/People";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { Tooltip } from "@mui/material";

const BarraNavegacion = ({ titulo, onLogout }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const [anchorElMaestros, setAnchorElMaestros] = useState(null);
  const [anchorElProcesos, setAnchorElProcesos] = useState(null);
  const [anchorElFacturacion, setAnchorElFacturacion] = useState(null); // 👈 submenu facturación

  const openMaestros = Boolean(anchorElMaestros);
  const openProcesos = Boolean(anchorElProcesos);
  const openFacturacion = Boolean(anchorElFacturacion);

  const handleNavigate = (path, closeMenuFn) => {
    closeMenuFn();
    navigate(path);
  };

  const menuMaestros = [
    { label: "Articulos", path: "/Articulos" },
    { label: "Configuracion", path: "/Configuracion" },
    { label: "Formas de Pago", path: "/FormasDePago" },
    { label: "Impuestos", path: "/Impuestos" },
    { label: "Proveedores", path: "/Proveedores" },
    { label: "Series", path: "/Series" },
  ];

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            textDecoration: "none",
            color: "inherit",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          {isMobile ? "Cocantra" : titulo || "Coop. Cántabra de Transportes"}
        </Typography>

        <Tooltip title="Clientes" arrow>
          <Button
            color="inherit"
            component={Link}
            to="/Clientes"
            startIcon={<PeopleIcon />} />
        </Tooltip>

        <Tooltip title="Socios" arrow>
          <Button
            color="inherit"
            component={Link}
            to="/Socios"
            startIcon={<LocalShippingIcon />} />
        </Tooltip>

        <Tooltip title="Viajes" arrow>
          <Button
            color="inherit"
            component={Link}
            to="/Viajes"
            startIcon={<TravelExploreIcon />} />
        </Tooltip>

        <Tooltip title="Dashboard" arrow>
          <Button
            color="inherit"
            component={Link}
            to="/">Dashboard
          </Button>
        </Tooltip>

        {/* Menú Maestros */}
        <Button color="inherit" onClick={(e) => setAnchorElMaestros(e.currentTarget)}>
          {isMobile ? "Def" : "Maestros"}
        </Button>
        <Menu
          anchorEl={anchorElMaestros}
          open={openMaestros}
          onClose={() => setAnchorElMaestros(null)}
        >
          {menuMaestros.map(({ label, path }) => (
            <MenuItem
              key={path}
              onClick={() => handleNavigate(path, () => setAnchorElMaestros(null))}
            >
              {label}
            </MenuItem>
          ))}
        </Menu>

        {/* Menú Taller */}
        <Button color="inherit" onClick={(e) => setAnchorElProcesos(e.currentTarget)}>
          {isMobile ? "Def" : "Taller"}
        </Button>
        <Menu
          anchorEl={anchorElProcesos}
          open={openProcesos}
          onClose={() => setAnchorElProcesos(null)}
        >
          <MenuItem onClick={() => handleNavigate("/AlbaranesTaller", () => setAnchorElProcesos(null))}>
            Albaranes Taller
          </MenuItem>

          <MenuItem onClick={() => handleNavigate("/ComprasTaller", () => setAnchorElProcesos(null))}>
            Compras Taller
          </MenuItem>

          <MenuItem onClick={() => handleNavigate("/Cuotas", () => setAnchorElFacturacion(null))}>
            Cuotas
          </MenuItem>

          {/* Submenú Facturación */}
          <MenuItem
            onClick={(e) => setAnchorElFacturacion(e.currentTarget)}
          >
            Facturas ▶
          </MenuItem>
          <Menu
            anchorEl={anchorElFacturacion}
            open={openFacturacion}
            onClose={() => setAnchorElFacturacion(null)}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >

            <MenuItem onClick={() => handleNavigate("/FacturacionTaller", () => setAnchorElFacturacion(null))}>
              Facturacion Automatica
            </MenuItem>
            <MenuItem onClick={() => handleNavigate("/FacturasTaller", () => setAnchorElFacturacion(null))}>
              Acceso a Facturas
            </MenuItem>
          </Menu>

        </Menu>

        {/* Logout */}
        <Button color="inherit" onClick={onLogout}>
          {isMobile ? <LogoutIcon /> : "Logout"}
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default BarraNavegacion;
